import i18n from '@/plugins/i18n'
import { NavigationState } from '@/types/state'
import * as getterTypes from '@/store/getter-types'
import { NavigationItem } from '@/types'

const state: NavigationState = {
  drawerNavigationItems: [
    {
      label: i18n.t('navigationItem.dashboardLabel'),
      icon: 'fal fa-grip-horizontal',
      routeName: 'Dashboard',
      key: 'dashboard',
    },
    {
      label: i18n.t('navigationItem.dailyMenuLabel'),
      icon: 'fas fa-utensils',
      routeName: 'Order',
      key: 'daily_menu',
    },
    {
      label: i18n.t('navigationItem.dailyMenuOrderLabel'),
      icon: 'fas fa-calendar-star',
      routeName: 'myOrder',
      key: 'my_orders',
    },
    {
      label: i18n.t('navigationItem.creditPageLabel'),
      icon: 'fal fa-euro-sign',
      routeName: 'Credit',
      key: 'credit',
    },
    {
      label: i18n.t('navigationItem.billingPageLabel'),
      icon: 'fal fa-file-invoice',
      routeName: 'Billing',
      key: 'billing',
    },

  ]
}

const getters = {
  [getterTypes.NAVIGATION_DRAWER_ITEMS] (state: NavigationState): NavigationItem[] {
    return state.drawerNavigationItems
  }
}

const mutations = {}

const actions = {}

const navigationModule = {
  state,
  getters,
  mutations,
  actions
}

export default navigationModule
